// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"formattedInputFieldValue_wrapper__5Fyuf","thumbnail":"formattedInputFieldValue_thumbnail__cPSds"};